export function paintOverlay(canvas, video, boxes, accent, mirrored) {
    if (!canvas || !video) return
    const rect = video.getBoundingClientRect()
    const dpr = window.devicePixelRatio || 1
    const w = Math.round(rect.width)
    const h = Math.round(rect.height)
    const vw = video.videoWidth
    const vh = video.videoHeight
    if (!w || !h || !vw || !vh) return

    if (canvas.width !== w * dpr || canvas.height !== h * dpr) {
        canvas.width = w * dpr
        canvas.height = h * dpr
    }
    canvas.style.width = `${w}px`
    canvas.style.height = `${h}px`

    const ctx = canvas.getContext('2d')
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
    ctx.clearRect(0, 0, w, h)

    if (!boxes || !boxes.length) return

    // Map normalised video-space coords through an object-fit: cover transform.
    const scale = Math.max(w / vw, h / vh)
    const dispW = vw * scale
    const dispH = vh * scale
    const offX = (w - dispW) / 2
    const offY = (h - dispH) / 2

    ctx.font = '600 14px Halcyon_SemiBold, sans-serif'
    ctx.textBaseline = 'bottom'
    ctx.lineWidth = 3

    // Map a normalized point through the cover transform + mirror.
    const mapPt = (p) => {
        let px = p.x * dispW + offX
        const py = p.y * dispH + offY
        if (mirrored) px = w - px
        return [px, py]
    }

    for (const box of boxes) {
        // Polyline entries (trajectory / crossing line / finger drawing).
        if (box.path && box.path.length) {
            ctx.strokeStyle = box.accent || accent || '#9b6ef3'
            ctx.lineWidth = box.lineWidth || 3
            ctx.lineJoin = 'round'
            ctx.lineCap = 'round'
            if (box.dashed) ctx.setLineDash([8, 6])
            ctx.beginPath()
            const pp = box.path.map(mapPt)
            if (box.curve && pp.length > 2) {
                // Smooth curve through a dense point stream: quadratic segments
                // whose control point is each point and whose end is the
                // midpoint to the next point.
                ctx.moveTo(pp[0][0], pp[0][1])
                for (let i = 1; i < pp.length - 1; i++) {
                    const mx = (pp[i][0] + pp[i + 1][0]) / 2
                    const my = (pp[i][1] + pp[i + 1][1]) / 2
                    ctx.quadraticCurveTo(pp[i][0], pp[i][1], mx, my)
                }
                const last = pp[pp.length - 1]
                ctx.lineTo(last[0], last[1])
            } else {
                pp.forEach(([px, py], i) =>
                    i ? ctx.lineTo(px, py) : ctx.moveTo(px, py)
                )
            }
            ctx.stroke()
            ctx.setLineDash([])
            continue
        }
        const color = box.accent || accent || '#22c55e'
        const bw = box.w * dispW
        const bh = box.h * dispH
        let bx = box.x * dispW + offX
        const by = box.y * dispH + offY
        if (mirrored) bx = w - (bx + bw)

        ctx.strokeStyle = color
        ctx.strokeRect(bx, by, bw, bh)

        if (box.label) {
            const padX = 6
            const textW = ctx.measureText(box.label).width
            const tagH = 20
            const tagY = by - tagH < 0 ? by + bh : by - tagH
            ctx.fillStyle = color
            ctx.fillRect(bx - ctx.lineWidth / 2, tagY, textW + padX * 2, tagH)
            ctx.fillStyle = '#ffffff'
            ctx.fillText(box.label, bx + padX, tagY + tagH - 4)
        }
    }
}

export function clearOverlay(canvas) {
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, canvas.width, canvas.height)
}
